import { Plugins, registerWebPlugin, WebPlugin } from '@capacitor/core';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const { Filesystem } = Plugins;
// By choosing a chunk size which is a multiple of 3, we avoid a bug in
// Filesystem.appendFile, only on the web platform, which corrupts files by
// inserting Base64 padding characters within the file. See
// https://github.com/ionic-team/capacitor-plugins/issues/649.
const chunkSize = 3 * 128 * 1024;
function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    let i = 0;
    while (i < bytes.byteLength) {
        binary += String.fromCharCode(bytes[i]);
        i++;
    }
    return btoa(binary);
}
function append(directory, path, data) {
    if (data.size === 0) {
        return Promise.resolve();
    }
    return new Response(data.slice(0, chunkSize)).arrayBuffer().then(function (buffer) {
        return Filesystem.appendFile({
            directory,
            path,
            data: arrayBufferToBase64(buffer),
        });
    }).then(function () {
        return append(directory, path, data.slice(chunkSize));
    });
}
function writeFileViaBridge(directory, path, data, recursive) {
    // create & truncate file
    return Filesystem.writeFile({
        directory,
        path,
        recursive,
        data: '',
    }).then(function ({ uri }) {
        // write file incrementally to be enconomical with memory
        return append(directory, path, data).then(function () {
            return uri;
        });
    });
}
var writeFileViaBridge$1 = Object.freeze(writeFileViaBridge);

class BlobWriterWeb extends WebPlugin {
    constructor() {
        super({
            name: 'BlobWriter',
            platforms: ['web']
        });
    }
    getConfig() {
        const err = new Error('Not implemented for web');
        err.code = 'NOT_IMPLEMENTED';
        return Promise.reject(err);
    }
}
const BlobWriter = new BlobWriterWeb();
registerWebPlugin(BlobWriter);
function writeFile(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const [{ baseUrl, authToken }, { uri }] = yield Promise.all([
                Plugins.BlobWriter.getConfig(),
                Plugins.Filesystem.getUri({
                    path: options.path,
                    directory: options.directory,
                }),
            ]);
            const absolutePath = uri.replace('file://', '');
            const queryString = options.recursive ? '?recursive=true' : '';
            const url = baseUrl + absolutePath + queryString;
            const { status } = yield fetch(url, {
                headers: { authorization: authToken },
                method: 'put',
                body: options.data,
            });
            if (status !== 204) {
                throw new Error('unexpected HTTP status: ' + status);
            }
            return { uri };
        }
        catch (err) {
            if (typeof options.fallback === 'function'
                ? options.fallback(err)
                : options.fallback !== false) {
                if (err.code !== 'NOT_IMPLEMENTED') {
                    console.error(err);
                }
                return writeFileViaBridge$1(options.directory, options.path, options.data, options.recursive).then(function (uri) {
                    return { uri };
                });
            }
            throw err;
        }
    });
}

export { writeFile };
//# sourceMappingURL=plugin.esm.js.map
